import { render } from "./LHomeFooter.vue?vue&type=template&id=cbd19ecc&scoped=true&ts=true"
import script from "./LHomeFooter.vue?vue&type=script&lang=ts"
export * from "./LHomeFooter.vue?vue&type=script&lang=ts"

import "./LHomeFooter.vue?vue&type=style&index=0&id=cbd19ecc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd19ecc"]])

export default __exports__